import {
    Component,
    Input,
    ViewEncapsulation,
    OnChanges,
    SimpleChanges,
    WritableSignal,
    signal,
    OnInit,
    Output,
    EventEmitter
} from '@angular/core';
import {CommonModule, NgIf, DatePipe} from '@angular/common';
import {TableModule} from 'primeng/table';
import {TagModule} from 'primeng/tag';
import {AccordionModule} from 'primeng/accordion';
import {TabViewModule} from 'primeng/tabview';
import {TooltipModule} from 'primeng/tooltip';
import {InputNumberModule} from 'primeng/inputnumber';
import {PrimeNgModule} from 'src/app/shared/prime-ng/prime-ng.module';
import {
    FieldGroups,
    FieldLabelsAntecedentesInterface,
    FieldLabelsService,
    ObtencionGenerica
} from '../interface/ver-proyecto.interface';
import {ProyectoService} from '../../../services/proyecto.service';
import Swal from "sweetalert2";
import { LoginServices } from 'src/app/auth/login/services/login.service';

@Component({
    selector: 'app-display-registro-profesional',
    templateUrl: './display-registro-profesional.component.html',
    styleUrls: ['./display-registro-profesional.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        TableModule,
        NgIf,
        TagModule,
        AccordionModule,
        TabViewModule,
        TooltipModule,
        InputNumberModule,
        PrimeNgModule
    ],
    providers: [DatePipe]
})
export class DisplayRegistroProfesionalComponent implements OnInit {

    @Input() registro: ObtencionGenerica = {};
    @Input() solicitud: number | null | undefined = null;
    @Output() registroChange = new EventEmitter<ObtencionGenerica>();
    @Input() registroProfesional_Antecedentes: ObtencionGenerica = {};

    private fieldLabels = FieldLabelsService;
    public groupedData: any[] = [];

    mostrarDialogo = false;
    fechaDialog: Date | null = null;
    minFecha: Date = new Date();
    registroSeleccionado: any | null = null;
    showLoader:WritableSignal<boolean> = signal(false);

    constructor(private datePipe: DatePipe, private proyectoService: ProyectoService, public ls: LoginServices) {
    }

    ngOnInit(): void {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['registro']) {
            this.groupedData = this.buildGroupedData();
        }
    }

    // Construye los datos agrupados y formateados una sola vez
    private buildGroupedData(): any[] {
        return FieldGroups.map(group => ({
            ...group,
            items: group.fields
                .map(key => ({
                    key,
                    value: this.getNestedValue(key),
                    label: this.getLabel(key),
                    formattedValue: this.formatValue(this.getNestedValue(key))
                }))
                .filter(item => item.value !== undefined)
        }));
    }

    // Se obtiene el valor del objeto anidado
    getNestedValue(key: string): any {
        const keys = key.split('.');
        let value = this.registro;

        for (const k of keys) {
            if (value && Object.hasOwn(value, k)) {
                value = value[k];
            } else {
                return undefined;
            }
        }
        return value;
    }

    // Se obtiene el label del campo
    getLabel(key: keyof typeof this.fieldLabels): string {
        return this.fieldLabels[key] || key;
    }

    // Se formatea el valor de forma eficiente
    formatValue(value: any): string {
        if (!value) return '';

        // Verificar si el valor es una cadena con formato ISO de fecha
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
            // Dividir la fecha en partes (año, mes, día) para evitar ajustes de zona horaria
            const [year, month, day] = value.split('-').map(Number);
            if (year && month && day) {
                // Crear una fecha sin ajustes de zona horaria
                return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
            }
        }

        // Verificar si el valor es un objeto Date
        if (value instanceof Date && !isNaN(value.getTime())) {
            return this.datePipe.transform(value, 'dd/MM/yyyy') || '';
        }

        // Si no es una fecha, devolver el valor como cadena
        return value.toString();
    }

    abrirDialogoFechas() {
        this.mostrarDialogo = true;
    }

    cancelarDialogo() {
        this.fechaDialog = null;
        this.mostrarDialogo = false
    }

    guardarFecha() {
        if (!this.fechaDialog) return;
        console.log('Fecha seleccionada (Date object):', this.fechaDialog);
        console.log('Fecha formateada:', this.formatDate(this.fechaDialog));
        this.showLoader.set(true);
        //OBTENER ID DE LA SOLICITUD
        const payload = {
            idSolicitud: this.solicitud!,
            fechaPermiso: '',
            fechaVencimiento: this.formatDate(this.fechaDialog!)
        };
        this.proyectoService.actualizarFechaVencimiento(payload) .subscribe({
            next: (result) => {
            },
            complete: () => {
                const nuevoRegistro = {
                    ...this.registro,
                    fechaVencimientoCarnet: this.formatDate(this.fechaDialog!)
                };
                this.registroChange.emit(nuevoRegistro);
                this.showLoader.set(false);
                this.cancelarDialogo();
                Swal.fire({
                    icon: 'success',
                    text: 'Fecha actualizada correctamente'
                });
            },
            error: (error) => {
                this.cancelarDialogo();
                console.log(error)
                this.showLoader.set(false);
                Swal.fire({
                    icon: 'error',
                    text: error.error?.message
                });
            }
        });
    }


    private formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}
